import { useTranslation } from '@portals-platform/i18n';
import { FormField, FormGrid, TextareaField } from '@portals-platform/ui-forms';
import { useFieldText } from '../../../hooks/use-field-text.js';
import { FIELD_CONFIG } from '../../../lib/new-certificate/fields.js';
import { CertificateSection } from './certificate-section.js';

export function AdditionalInfoSection() {
  const { t } = useTranslation();
  const { label, placeholder } = useFieldText(FIELD_CONFIG.additionalComments);

  return (
    <CertificateSection title={t('certificates.new.sections.additionalInformation')}>
      <FormGrid>
        <FormField name="additionalComments" label={label} optional col={12}>
          <TextareaField name="additionalComments" rows={3} placeholder={placeholder} />
        </FormField>
      </FormGrid>
    </CertificateSection>
  );
}
